<template>
  <div class="comContent">
    <div class="title">
      <div>
        <span class="font">资质字段</span>
      </div>
    </div>
    <div class="btns">
      <el-button size="small"
                 type="primary"
                 @click="addItem"> 新增 </el-button>
    </div>
    <div class="center">
      <MyTable :table-data="tableData"
               :showpage="false"
               :index="false"
               :operation="true"
               :table-option.sync="tableOption">
        <template slot="menu"
                  slot-scope="scope">
          <el-link :underline="false"
                   type="primary"
                   @click="editItem(scope.row)">编辑</el-link>
          <el-popconfirm title="确定删除吗？"
                         @confirm="deleteItem(scope.row)">
            <el-link :underline="false"
                     style="margin-left: 16px"
                     type="primary"
                     slot="reference">删除</el-link>
          </el-popconfirm>
        </template>
      </MyTable>
    </div>
    <ConfirmDialog :dialogShow="documentsDialogShow"
                   :title="title"
                   :showFooter="true"
                   :width="800"
                   @updateDialogShow="updateDialogShow"
                   @confirm="confirm">
      <el-form label-width="80px"
               :model="form"
               ref="form"
               class="form"
               :rules="formRules"
               size="mini"
               @submit.native.prevent>
        <el-form-item label="关联证件"
                      prop="certificateId">
          <el-select v-model="form.certificateId"
                     size="small"
                     placeholder="请选择"
                     style="width: 100%">
            <el-option v-for="(item, i) in selectList"
                       :key="i"
                       :label="item.name"
                       :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="字段名称"
                      prop="name">
          <el-input v-model="form.name"
                    maxlength="50"></el-input>
        </el-form-item>
        <!-- <el-form-item label="字段标识" prop="fieldName">
          <el-input
            v-model="form.fieldName"
            maxlength="50"
            :disabled="type == 'edit'"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="排序"
                      prop="sort">
          <el-input type="number"
                    v-model="form.sort"></el-input>
        </el-form-item>
        <el-form-item label="录入方式"
                      prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="1">文本框</el-radio>
            <el-radio :label="2">下拉框</el-radio>
            <el-radio :label="3">地址选择器</el-radio>
            <el-radio :label="4">复选框</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.type == 2 || form.type == 4"
                      label="枚举值"
                      prop="selectEnum">
          <el-input placeholder="枚举值1,枚举值2,枚举值3"
                    v-model="form.selectEnum"
                    type="textarea"
                    :rows="3"
                    maxlength="1000"></el-input>
        </el-form-item>
      </el-form>
    </ConfirmDialog>
  </div>
</template>
<script>
import MyTable from "@/components/myTable";
import ConfirmDialog from "@/components/ConfirmDialog";
import {
  saveCompcertificatesfields,
  getCompcertificatesAllList,
  getCompcertificatesfieldsList,
  updateCompcertificatesfields,
  deleteCompcertificatesfields,
} from "@/api/qualification/qualification";

export default {
  name: "QualificationDocumentsManager",
  components: { MyTable, ConfirmDialog },
  computed: {
    title () {
      if (this.type == "add") {
        return "新增资质字段";
      } else {
        return "编辑资质字段";
      }
    },
  },
  data () {
    return {
      type: "add", //add,edit
      documentsDialogShow: false,
      form: {
        certificateId: "",
        name: "",
        // fieldName: "",
        sort: "",
        type: 1, //1-文本框，2-下拉框，3-地址选择器，4-复选框
        selectEnum: "",
      },
      formRules: {
        certificateId: [
          { required: true, message: "请选择证件", trigger: "change" },
        ],
        name: [
          { required: true, message: "请输入字段名称", trigger: "change" },
        ],
        // fieldName: [
        //   { required: true, message: "请输入字段英文标识", trigger: "change" },
        // ],
        sort: [
          { required: true, message: "请输入排序数字", trigger: "change" },
        ],
        certificateId: [
          { required: true, message: "请输入关联证件", trigger: "change" },
        ],
      },
      selectList: [],
      tableOption: [
        { label: "字段名称", prop: "name" },
        { label: "字段标识", prop: "fieldName" },
        { label: "排序", prop: "sort" },
        { label: "关联证件", prop: "certificateName" },
      ],
      tableData: [],
    };
  },
  methods: {
    queryTable () {
      getCompcertificatesfieldsList().then((res) => {
        this.tableData = res.data.map((item) => {
          if (item.selectEnum) {
            try {
              item.selectEnum = String(
                Object.values(JSON.parse(item.selectEnum))
              );
            } catch (error) { }
          }
          return item;
        });
      });
    },
    updateDialogShow (vis) {
      this.documentsDialogShow = vis;
    },
    resetForm () {
      this.form = {
        id: undefined,
        name: "",
        // fieldName: "",
        sort: "",
        certificateId: "",
        selectEnum: "",
        type: 1,
      };
    },
    initForm (row) {
      this.form = Object.assign(this.form, row);
    },
    confirm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            saveCompcertificatesfields({
              name: this.form.name,
              // fieldName: this.form.fieldName,
              certificateId: this.form.certificateId,
              sort: this.form.sort,
              type: this.form.type,
              selectEnum: this.transSelectEnum(this.form.selectEnum),
            }).then((res) => {
              this.$message.success("操作成功");
              this.queryTable();
            });
          } else {
            updateCompcertificatesfields({
              id: this.form.certifyId,
              name: this.form.name,
              fieldName: this.form.fieldName,
              certificateId: this.form.certificateId,
              sort: this.form.sort,
              type: this.form.type,
              selectEnum: this.form.selectEnum ? this.transSelectEnum(this.form.selectEnum) : '',
            }).then((res) => {
              this.$message.success("操作成功");
              this.queryTable();
            });
          }
          this.updateDialogShow(false);
        }
      });
    },
    transSelectEnum (selectEnum) {
      selectEnum = selectEnum.replace(new RegExp('，', 'g'), ',')
      const array = selectEnum.split(",");
      const obj = {};
      array.forEach((arr, index) => {
        obj[index + 1] = arr;
      });
      return JSON.stringify(obj);
    },
    addItem () {
      this.type = "add";
      this.resetForm();
      this.updateDialogShow(true);
    },
    editItem (row) {
      this.type = "edit";
      this.initForm(row);
      this.updateDialogShow(true);
    },
    deleteItem (row) {
      deleteCompcertificatesfields({
        id: row.certifyId,
      }).then((res) => {
        this.$message.success("删除成功");
        this.queryTable();
      });
    },
  },
  mounted () {
    getCompcertificatesAllList().then((res) => {
      this.selectList = res.data;
    });
    this.queryTable();
  },
};
</script>
<style lang='scss' scoped>
.comContent {
  padding: 0px;
  .title {
    height: 56px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f5f5ff;
  }
  .center {
    margin: 0 24px;
    margin-top: 16px;
    height: calc(100% - 131px);
    width: auto;
  }
  .btns {
    margin: 0 24px;
    margin-top: 16px;
  }
  .font-tip {
    padding-left: 10px;
    font-size: 12px;
    color: rgb(238, 214, 82);
  }
}
</style>